import { render } from "./Cod3Page.vue?vue&type=template&id=3e30475c&scoped=true"
import script from "./Cod3Page.vue?vue&type=script&lang=js"
export * from "./Cod3Page.vue?vue&type=script&lang=js"

import "./Cod3Page.vue?vue&type=style&index=0&id=3e30475c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e30475c"]])

export default __exports__